import { emailJsConfig } from './config'
import emailjs from '@emailjs/browser';

export interface SendEmailParams {
  formData_name: string
  formData_email: string 
  formData_phone: string
  formData_subject: string
  formData_message: string 
}

export const senderService = {
  // Send email using Resend
  sendEmail: async (params: SendEmailParams) => {
    try {
      await emailjs.send(
        emailJsConfig.serviceId,    // Service ID
        emailJsConfig.templateId,   // Template ID  
        {
          formData_name: params.formData_name,
          formData_email: params.formData_email,
          formData_phone: params.formData_phone,
          formData_subject: params.formData_subject,
          formData_message: params.formData_message,
        }
      );
    } catch (error: any) {
      throw new Error(error.message || 'Failed to send email')
    }
  }

}